import styled from 'styled-components';

export const StyledLabel = styled.label`
    width: auto;
    height: 100%;
    font-size: ${({theme}) => theme.fontSizes.sm};
`;
